
import React, { useState } from "react";
import './contact.css';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";

const Contact = () => {
    const [form, setForm] = useState({
        name: "",
        phone: "",
        email: "",
        state: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);


    // const EMAILJS_SERVICE_ID = "service_en7eoep";
    // const EMAILJS_TEMPLATE_ID = "template_wm3fxal";
    // const EMAILJS_PUBLIC_KEY = "EwW3WLTvoF5mKxTkS";

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const validateEmail = (email) => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    };

    const validateForm = () => {
        const { name, phone, email, state, message } = form;
        if (!name.trim() || !phone.trim() || !email.trim() || !state.trim() || !message.trim()) {
            toast.error("Please fill in all fields.",
                {
                    theme: "dark",
                }

            );
            return false;
        }


        if (!validateEmail(email)) {
            toast.error("Please enter a valid email address.",
                {
                    theme: "dark",
                }
            );
            return;
        }
        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        // setLoading(true);
        setLoading(false);
        toast.success("Message sent successfully!",
            {
                theme: "dark",
            }
        );
        setForm({ name: "", phone: "", email: "", state: "", message: "" });

        // const templateParams = {
        //     name: form.name,
        //     phone: form.phone,
        //     email: form.email,
        //     state: form.state,
        //     message: form.message
        // };

        // emailjs
        //     .send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY)
        //     .then(
        //         (result) => {
        //             setLoading(false);
        //             toast.success("Message sent successfully!");
        //             setForm({ name: "", phone: "", email: "", state: "", message: "" });
        //         },
        //         (error) => {
        //             setLoading(false);
        //             console.error("EmailJS error:", error);
        //             toast.error("Failed to send. Please try again later.");
        //         }
        //     );
    };

    return (

        <>
            <div className='top-img'>
                <img src={require("../../assets/vecteezy_man-pointing-at-a-wooden-block-communication-concept-with_21698967.jpg")} alt="" />
                <div className="top-content">
                    <h1>Contact Us</h1>
                    <div className="top-link">
                        <div className='home-link'>  <Link to="/" >Home</Link> </div>
                        <div className='currentpage'>Contact Us</div>
                    </div>

                </div>

            </div>

            <section className="contact-section" data-aos="fade-up">
                <ToastContainer position="top-right" autoClose={4000} />
                <div className="contact-container">
                    {/* LEFT INFO */}
                    <div className="contact-info">
                        <div className="info-top">
                            <h2>Contact Us</h2>
                            <p className="muted">
                                For inquiries, support or partnership — drop us a message.
                            </p>
                        </div>

                        <div className="info-cards">
                            <div className="info-card">
                                <div className="icon-box"><FaPhoneAlt /></div>
                                <div className="info-text">
                                    <h4>Phone</h4>
                                    <p>+91 9344931339</p>
                                </div>
                            </div>

                            <div className="info-card">
                                <div className="icon-box"><FaEnvelope /></div>
                                <div className="info-text">
                                    <h4>Email</h4>
                                    <p>director@roobaswastha.com</p>
                                </div>
                            </div>

                            <div className="info-card">
                                <div className="icon-box"><FaMapMarkerAlt /></div>
                                <div className="info-text">
                                    <h4>Location</h4>
                                    <p>D.No.9-415/G, Yerraballi, Rajampet, Annamayya (Dt), Andhra Pradesh - 516 115</p>
                                </div>
                            </div>
                        </div>

                        <div className="image-wrapper" aria-hidden>

                            <img src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3&s=6a6b8f2c0b9426d2c1a5f45c8b7d9a36" alt="Office team" />
                        </div>
                    </div>

                    {/* RIGHT FORM */}
                    <form className="contact-form" onSubmit={handleSubmit} noValidate>
                        <h3>Send Us a Message</h3>
                        <div className="row">
                            <label className="sr-only" htmlFor="name">Name</label>
                            <input
                                id="name"
                                name="name"
                                placeholder="Name"
                                value={form.name}
                                onChange={handleChange}
                                type="text"
                            />
                        </div>

                        <div className="row">
                            <label className="sr-only" htmlFor="phone">Phone</label>
                            <input
                                id="phone"
                                name="phone"
                                placeholder="Phone Number"
                                value={form.phone}
                                onChange={handleChange}
                                type="tel"
                            />
                        </div>

                        <div className="row">
                            <label className="sr-only" htmlFor="email">Email</label>
                            <input
                                id="email"
                                name="email"
                                placeholder="Email Address"
                                value={form.email}
                                onChange={handleChange}
                                type="email"
                            />
                        </div>

                        <div className="row">
                            <label className="sr-only" htmlFor="state">State</label>
                            <input
                                id="state"
                                name="state"
                                placeholder="State"
                                value={form.state}
                                onChange={handleChange}
                                type="text"
                            />
                        </div>

                        <div className="row">
                            <label className="sr-only" htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                placeholder="Write Message"
                                value={form.message}
                                onChange={handleChange}
                                rows="5"
                            />
                        </div>

                        <div className="row">
                            <button type="submit" className="btn" disabled={loading}>
                                {loading ? "Sending..." : "Send Message"}
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </>



    );
};

export default Contact;
